/*
    Actions -> GeneriInterstitial
    Actions to diferrents interstitials (commercial, fioc, legal)
    We include here differents calls to API and functions to get and update
    data for interstitials

    1. ACTIONS
        - Get interstitial type actions
        - Get interstitial content actions

    2. CALLS TO API
        - Get interstitial type
        - Get FIOC content

    3. FUNCTIONS
        - Confirm interstitials clauses
*/

// @utils
const { getLanguage } = require('core/i18n').i18n;
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { recordCommercialSpaceV2 } = require('utilities/tagging');

// @actions
const { confirmClause } = require('actions/commercialInterstitialsAds');
const { getFiocStatus } = require('actions/fiocDocumentation');

// @constants
const actionTypes = require('constants/actionTypes');
const { COMMERCIAL_ADS_CHANNEL } = require('constants/index');
const { ADOBE } = require('constants/flagBasedFeatures');
const {
    ACTION_EVENT_VIEW,
    COMMERCIAL_ADS_TEALIUM_EVENT,
    COMMERCIAL_INTERSTITIAL_EVENT_CATEGORY,
} = require('constants/tagging');

// ACTIONS
// Get interstitial type actions
const fetchGetTypeInterstitialProgress = () => ({
    type: actionTypes.FETCH_GET_INTERSTITIAL_TYPE_IN_PROGRESS
});

const fetchGetTypeInterstitialSuccess = interstitialType => ({
    type: actionTypes.FETCH_GET_INTERSTITIAL_TYPE_SUCCESS,
    payload: interstitialType
});

const fetchGetTypeInterstitialFailure = (error) => ({
    type: actionTypes.FETCH_GET_INTERSTITIAL_TYPE_FAILURE,
    payload: { error }
});

// Get interstitial content actions
const fetchGetInterstitialContentProgress = () => ({
    type: actionTypes.FETCH_GET_INTERSTITIAL_CONTENT_IN_PROGRESS
});

const fetchGetInterstitialContentSuccess = interstitialContent => ({
    type: actionTypes.FETCH_GET_INTERSTITIAL_CONTENT_SUCCESS,
    payload: interstitialContent
});

const fetchGetInterstitialContentFailure = () => ({
    type: actionTypes.FETCH_GET_INTERSTITIAL_CONTENT_FAILURE
});
const handleAcceptLegalInProgress = () => ({
    type: actionTypes.HANDLE_ACCEPT_LEGAL_INPROGRESS
})
const handleAcceptLegalSuccess = interstitialAcceptSuccess => ({
    type: actionTypes.HANDLE_ACCEPT_LEGAL_SUCCESS,
    payload: interstitialAcceptSuccess
})
const handleAcceptLegalFailure = interstitialAcceptError => ({
    type: actionTypes.HANDLE_ACCEPT_LEGAL_FAILURE,
    payload: interstitialAcceptError
})
// CALLS TO API

//handle Accept Legal
const handleAcceptLegalAction = interstitialID => (dispatch) => {
    const requestData = {
        query: {
        "interstitialId": interstitialID
        }
    };
    dispatch(handleAcceptLegalInProgress());

    return APIPost(dispatch, apiURLBuilder.getURL('legalInterestitialAccept'), requestData)
        .then(response =>{
        return   dispatch(handleAcceptLegalSuccess(response))})
        
        .catch(response => {
            return  dispatch(handleAcceptLegalFailure(response))
        });
}; 

// Get interstitial type
const getTypeInterstitial = (originCountry) => (dispatch, getState) => {
    dispatch(fetchGetTypeInterstitialProgress());
    let currentPath = location.pathname;
    if(originCountry && originCountry === 'DE' && currentPath === '/myprofile'){
        currentPath = '/myprofile/global';
    }

    const requestData = {
        query: {
            channel: COMMERCIAL_ADS_CHANNEL,
            lang: getLanguage().toLowerCase(),
            interstitialPath: currentPath
        }
    };

    const isAdobeV2Enabled = getState().flagBasedFeatures.get(ADOBE);
    if (isAdobeV2Enabled) {
        requestData.header = {
            version: 2
        }
        requestData.query.locations = "C.2.6";
    } else {
        requestData.query.locations = "B.1.1";
    }

    dispatch(fetchGetTypeInterstitialProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('requestInterstitialsNotifications'), requestData)
    .then(response => {
        if (!!response && (response['interstitialType'] === 'commercial' || response['interstitialType'] === 'default')) {
            if (!__CONTACT_CENTER__ && isAdobeV2Enabled) {
                const taggingParams = {
                    categoriaEvento: COMMERCIAL_INTERSTITIAL_EVENT_CATEGORY + response['id'],
                    accionEvento: ACTION_EVENT_VIEW,
                    tealiumEvent: COMMERCIAL_ADS_TEALIUM_EVENT
                }
                recordCommercialSpaceV2(taggingParams);
            }
        }
        return dispatch(fetchGetTypeInterstitialSuccess(response));
    })
    .catch(response => {
        if (!!response.error) {
            dispatch(fetchGetTypeInterstitialFailure(response.error));
        } else {
            throw response;
        }
    });
}

// Get FIOC content
const getFiocContent = () => (dispatch) => {
    dispatch(fetchGetInterstitialContentProgress());

    return dispatch(getFiocStatus())
        .then(response => {
            return dispatch(fetchGetInterstitialContentSuccess(response));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(fetchGetInterstitialContentFailure(response.error));
            } else {
                throw response;
            }
        });
}

// FUNCTIONS
// Confirm interstitials clauses
const markInterstitialAsShown = () => (dispatch) => {
    dispatch({
        type: actionTypes.MARK_INTERSTITIAL_AS_SHOWN
    })
}

const confirmInterstitialClause = (clauseId, contentId) => (dispatch) => {
     dispatch(confirmClause(clauseId, contentId))
        .then(dispatch(markInterstitialAsShown()))
}

//Update Interstitial status
const updateInterstitialAdsStatus = (proposition) => (dispatch) => {
    const requestData = {
        header: {
            version: 2
        },
        query: {
            requestProposition: {
                propositions: {
                    proposition: proposition
                }
            },
            system: COMMERCIAL_ADS_CHANNEL
        }
    };
    return APIPost({dispatch,  endpoint: 'updateAds', params: requestData})
};

const setAdvancedInterstialFlag = () => (dispatch) => {
    dispatch ({
        type: actionTypes.ADVANCED_INTERSTITIAL_SET_FLAG
    })
}

const resetAdvancedInterstitialFlag = () => (dispatch) => {
    dispatch({
        type: actionTypes.ADVANCED_INTERSTITIAL_RESET_FLAG
    })
}

module.exports = {
    handleAcceptLegalAction,
    confirmInterstitialClause,
    getTypeInterstitial,
    getFiocContent,
    markInterstitialAsShown,
    resetAdvancedInterstitialFlag,
    setAdvancedInterstialFlag,
    updateInterstitialAdsStatus,
};
